import * as React from "react";

export const CommongroundLogo: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    width="180.000000pt"
    height="180.000000pt"
    viewBox="0 0 180.000000 180.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
      <path d="M302 1702 c-142 -51 -231 -189 -220 -341 7 -96 38 -151 145 -261 l92 -95 53 52 52 52 -82 84 c-45 47 -89 101 -97 120 -51 122 36 257 165 257 78 0 105 -21 383 -298 l267 -267 53 53 52 52 -280 279 c-209 208 -292 284 -329 301 -68 32 -181 38 -254 12z" />
      <path d="M1284 1706 c-58 -19 -117 -62 -204 -150 l-75 -76 52 -52 52 -52 84 82 c47 45 101 89 120 97 155 65 306 -88 242 -243 -11 -24 -108 -129 -283 -305 l-267 -267 53 -53 52 -52 279 280 c322 325 325 330 326 470 0 78 -4 97 -28 146 -32 67 -100 132 -165 162 -58 25 -180 33 -238 13z" />
      <path d="M409 883 c-320 -323 -323 -328 -324 -468 0 -78 4 -97 28 -146 32 -66 99 -132 165 -162 37 -17 66 -22 137 -22 119 0 161 21 285 142 l95 92 -52 53 -52 52 -84 -82 c-47 -45 -101 -89 -120 -97 -122 -51 -257 36 -257 165 0 78 21 105 298 382 l266 268 -49 50 c-27 27 -52 50 -55 50 -3 0 -130 -125 -281 -277z" />
      <path d="M685 740 l-50 -51 280 -278 c325 -322 330 -325 470 -326 78 0 97 4 146 28 66 32 132 99 162 165 17 37 22 66 22 137 0 119 -21 161 -142 285 l-92 95 -53 -52 -52 -52 82 -84 c45 -47 89 -101 97 -120 51 -122 -36 -257 -165 -257 -78 0 -105 21 -380 295 -146 146 -268 265 -271 265 -2 0 -27 -23 -54 -50z" />
    </g>
  </svg>
);
